import { useCallback, useState } from "react";

export default function useGetAveryTemplatesData() {
  const [isLoadingAveryLabels, setIsLoadingAveryLabels] =
    useState<boolean>(false);
  const [error, setError] = useState<any>(null);

  const fetchAveryLabels = useCallback(
    async (trustId: string, trustName: string) => {
      let url = `https://hometrustapi.azurewebsites.net/api/Templates/generate/averylabels/${trustId}`;

      setIsLoadingAveryLabels(true);
      setError(null);

      // console.log("getting Templates");
      try {
        await fetch(
          url, 
          { 
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            }, 
            method: "GET" 
          })
          .then((response) => response.blob())
          .then((blob) => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `${trustName}_Avery Labels`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
          })
          .catch((error) => console.error("Error downloading file:", error));
      } catch (error: any) {
        setError(error);
        setIsLoadingAveryLabels(false);
      }
    },
    []
  );

  return { isLoadingAveryLabels, error, fetchAveryLabels };
}
